
import React from 'react';
import { Zap, LineChart, Database } from 'lucide-react';

const FeatureCards = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-24 max-w-5xl mx-auto">
      <div className="feature-card reveal opacity-0 transition-all duration-700 translate-y-8" style={{ transitionDelay: '400ms' }}>
        <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4">
          <Zap className="w-6 h-6 text-blue-600" />
        </div>
        <h3 className="text-lg font-semibold mb-2">Automation That Saves Time</h3>
        <p className="text-gray-600">
          Save 100+ hours of manual work per fund per year with AI-powered data extraction and processing.
        </p>
      </div>
      
      <div className="feature-card reveal opacity-0 transition-all duration-700 translate-y-8" style={{ transitionDelay: '500ms' }}>
        <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4">
          <LineChart className="w-6 h-6 text-blue-600" />
        </div>
        <h3 className="text-lg font-semibold mb-2">Deeper Portfolio Insights</h3>
        <p className="text-gray-600">
          Gain unprecedented visibility into portfolio performance with trend analysis and benchmarking.
        </p>
      </div>
      
      <div className="feature-card reveal opacity-0 transition-all duration-700 translate-y-8" style={{ transitionDelay: '600ms' }}>
        <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4">
          <Database className="w-6 h-6 text-blue-600" />
        </div>
        <h3 className="text-lg font-semibold mb-2">Centralized Data Hub</h3>
        <p className="text-gray-600">
          Access all your fund and portfolio company data in one secure, searchable platform.
        </p>
      </div>
    </div>
  );
};

export default FeatureCards;
